import { render, staticRenderFns } from "./TemplateBrowserPreviewButton.vue?vue&type=template&id=78f2a22a&"
import script from "./TemplateBrowserPreviewButton.vue?vue&type=script&lang=js&"
export * from "./TemplateBrowserPreviewButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f2a22a')) {
      api.createRecord('78f2a22a', component.options)
    } else {
      api.reload('78f2a22a', component.options)
    }
    module.hot.accept("./TemplateBrowserPreviewButton.vue?vue&type=template&id=78f2a22a&", function () {
      api.rerender('78f2a22a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/TemplateBrowserPreviewButton.vue"
export default component.exports